(function () {

    angular
        .module('smartertoolsApp')
        .service('myAccountService',
            [
                'cacheControl', 'refreshToken', '$http', 'authenticationService', '$rootScope', '$window',
                myAccountService
            ]);

    function myAccountService(cacheControl, refreshToken, $http, authenticationService, $rootScope, $window) {
        const vm = this;
        vm.urlBase = apiRootUrl;
        vm.isLoggedIn = authenticationService.isLoggedIn();
        let promise1;

        // Functions
        vm.getAreaPermissions = getAreaPermissions;
        vm.processLoginChangeEvent = processLoginChangeEvent;

        activate();

        // -----------------------------------------------

        function activate() {
            $rootScope.$on('authentication:logged-in', (event, data) => {
                processLoginChangeEvent();
                $rootScope.$broadcast('myAccountService:changed', {});
                $window.location.reload();
            });
            $rootScope.$on('authentication:logged-out', (event, data) => {
                processLoginChangeEvent();
                $rootScope.$broadcast('myAccountService:changed', {});
                $window.location = "/";
            });
        }

        function getAreaPermissions() {
            promise1 = refreshToken.refreshToken()
                .then(() => {
                    promise1 = null;
                    return $http.get(`${vm.urlBase}v1/account/area-permissions`, {cache: cacheControl.getCache('myAccountCache')});
                })
                .then(response => {
                    promise1 = null;
                    return response.data;
                });
            return promise1;
        }

        function processLoginChangeEvent() {
            cacheControl.getCache('myAccountCache').remove(vm.urlBase + 'v1/account/area-permissions');
            refreshToken.clearCached();
            vm.isLoggedIn = authenticationService.isLoggedIn();
        }
    }

})();